export var PostStatus;
(function (PostStatus) {
    PostStatus[PostStatus["UNPOSTED"] = 1] = "UNPOSTED";
    PostStatus[PostStatus["POSTED"] = 2] = "POSTED";
})(PostStatus || (PostStatus = {}));
//# sourceMappingURL=post-status.js.map